import { render, staticRenderFns } from "./student-tag-item.vue?vue&type=template&id=93f67ee6&scoped=true"
import script from "./student-tag-item.vue?vue&type=script&lang=js"
export * from "./student-tag-item.vue?vue&type=script&lang=js"
import style0 from "./student-tag-item.vue?vue&type=style&index=0&id=93f67ee6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f67ee6",
  null
  
)

export default component.exports